import React from 'react';
import PropTypes from 'prop-types';
import FamilyTree from './familyTree/FamilyTree';

/**
 * FamilyTreeView
 * --------------
 * Thin wrapper meant to be embedded inside a modal.
 *
 * Core interaction requirement:
 * - Clicking a node logs the full character object
 */
const FamilyTreeView = ({
  characters,
  showSpouses,
  onClose,
  title,
  onNodeClick,
  centerOnCharacterId,
}) => {
  const handleNodeClick = (character) => {
    // If character has __original, log that instead (for transformed characters)
    if (character && character.__original) {
      console.log(character.__original);
      if (onNodeClick) onNodeClick(character.__original);
    } else {
      console.log(character);
      if (onNodeClick) onNodeClick(character);
    }
  };

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 12px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(2, 6, 23, 0.98)',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      >
        <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: 14, fontWeight: 600 }}>
          {title || 'Family Tree'}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            style={{
              border: '1px solid rgba(255,255,255,0.18)',
              background: 'transparent',
              color: 'rgba(255,255,255,0.85)',
              borderRadius: 8,
              padding: '6px 10px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        )}
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        <FamilyTree
          characters={characters}
          showSpouses={showSpouses}
          onNodeClick={handleNodeClick}
          centerOnCharacterId={centerOnCharacterId}
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        />
      </div>
    </div>
  );
};

FamilyTreeView.propTypes = {
  characters: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string,
      connections: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  showSpouses: PropTypes.bool,
  onClose: PropTypes.func,
  onNodeClick: PropTypes.func,
  title: PropTypes.string,
  centerOnCharacterId: PropTypes.string,
};

FamilyTreeView.defaultProps = {
  characters: [],
  showSpouses: true,
  onClose: null,
  onNodeClick: null,
  title: null,
  centerOnCharacterId: null,
};

export default FamilyTreeView;
